import {
  Collapse,
  Grid,
  IconButton,
  TableCell,
  TableRow,
  Button,
} from "@material-ui/core";
import React from "react";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import SimpleGridItem from "./SimpleGridItem";
import { useStore } from "../store/Store";
import { Link } from "react-router-dom";

const PublicationRow = (publicationProps: {
  publication: System.Publication;
  open: boolean;
}) => {
  const { state } = useStore();
  const { publication } = publicationProps;
  const [open, setOpen] = React.useState(publicationProps.open);

  return (
    <>
      <TableRow className={open ? "hightlight-background" : ""}>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell>{publication.year}</TableCell>
        <TableCell>{publication.title}</TableCell>
        <TableCell>{publication.authors}</TableCell>
        <TableCell>
          <a
            href={"http://doi.org/" + publication.doi}
            target="_blank"
            rel="noopener noreferrer"
          >
            {publication.doi}
          </a>
        </TableCell>
        <TableCell style={{ width: "15rem" }}>
          {publication.allKeywords.length !== 0 &&
            (publication.allKeywords.length
              ? publication.allKeywords.map(
                  (model, i) =>
                    model.tags_model.name +
                    (publication.allKeywords.length === i + 1 ? "" : ", ")
                )
              : "")}
        </TableCell>
        {state.user.isAdmin ? (
          <TableCell>
            <Link to={"/publication/" + publication.id} className="link">
              <Button variant="contained" color="secondary">
                Edit
              </Button>
            </Link>
          </TableCell>
        ) : (
          <></>
        )}
      </TableRow>
      <TableRow>
        <TableCell className={"highlight-row"} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Grid container spacing={2} style={{ padding: "1em 0em" }}>
              {publication.journal && (
                <SimpleGridItem
                  title="Journal"
                  value={publication.journal}
                  size={4}
                />
              )}
              {publication.volume && (
                <SimpleGridItem
                  title="Volume"
                  value={
                    publication.volume ? publication.volume.toString() : ""
                  }
                  size={4}
                />
              )}
              {publication.pages && (
                <SimpleGridItem
                  title="Page"
                  value={publication.pages ? publication.pages : ""}
                  size={4}
                />
              )}
              {publication.editors && (
                <SimpleGridItem
                  title="Editors"
                  value={
                    publication.editors ? publication.editors.toString() : ""
                  }
                  size={4}
                />
              )}
              {publication.publisher && (
                <SimpleGridItem
                  title="Publisher"
                  value={
                    publication.publisher
                      ? publication.publisher.toString()
                      : ""
                  }
                  size={4}
                />
              )}
              {publication.publisher_place && (
                <SimpleGridItem
                  title="Publisher Place"
                  value={
                    publication.publisher_place
                      ? publication.publisher_place.toString()
                      : ""
                  }
                  size={4}
                />
              )}
            </Grid>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
};

export default PublicationRow;
